import { render, staticRenderFns } from "./ok-header.vue?vue&type=template&id=45805df6&scoped=true&"
import script from "./ok-header.vue?vue&type=script&lang=js&"
export * from "./ok-header.vue?vue&type=script&lang=js&"
import style0 from "./ok-header.vue?vue&type=style&index=0&id=45805df6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45805df6",
  null
  
)

export default component.exports